import Raven from 'raven-js';
import UAFormat from 'ua-format-js';
import _ from 'lodash';

const { get, merge, includes } = _;

function getCookie(cookieName) {
    const strCookie = document.cookie;
    const arrCookie = strCookie.split('; ');
    for (let i = 0; i < arrCookie.length; i += 1) {
        const arr = arrCookie[i].split('=');
        if (cookieName === arr[0]) {
            return arr[1];
        }
    }
    return '';
}

function getProductByPage(page) {
    const workspacePageList = ['WorkSpace'];
    const homePageList = ['Group Assignees', 'History', 'Paper'];
    if (includes(homePageList, page)) {
        return 'Home';
    }
    if (includes(workspacePageList, page)) {
        return 'Workspace';
    }
    return 'ANALYTICS';
}

let unpushedTrackEventsStack = [];

/**
 * 根据域名计算 site_region
 * // zhihuiya.com => CN
 * // patsnap.com => US
 * // patsnap.eu => EU
 * @param {string} host
 */
function getRegionByHost() {
    const domain = window.location.host;
    if (domain.includes('patsnap.com')) {
        return 'US';
    }
    if (domain.includes('patsnap.eu')) {
        return 'EU';
    }
    return 'CN';
}

export default async (Vue, page, opts = {}) => {
    const cid = getCookie('CLIENT_ID');

    const email = opts.email;
    const accountId = opts.accountId;
    const companyId = opts.companyId;
    const companyName = opts.companyName;
    const userType = opts.userType;
    const needTrack = opts.needTrack;

    let environment = window.location.host.split('.')[0];
    environment = environment === '127' ? 'dev-analytics' : environment;
    let formater = new UAFormat();
    let UAresult = formater.getResult();
    if (needTrack && environment !== 'dev-analytics' && window.location.search.indexOf('noraven=1') < 0) {
        var data = {
            id: accountId,
            email,
            os: UAresult.os.name,
            browser: UAresult.browser.name,
            b_ver: UAresult.browser.version,
            account_id_cipher: accountId,
            company_id_cipher: companyId,
            company_name: companyName,
            user_type: userType
        };
        if (cid) {
            Object.assign(data, { client_id: cid });
        }

        if (get(opts, 'noVue', false)) {
            opts.customProcess(Raven);
        }

        Raven.setUserContext(data);

        await import('@patsnap/common-ps-tracer')
            .then(m => (m.default ? m.default : m))
            .then(sentryPsPlugin => {
                const product = getProductByPage(page);
                sentryPsPlugin(Raven, {
                    redShiftIntegrationName: 'redshift-segmentdb',
                    product,
                    page: page,
                    openSpendTimeTrack: true
                });
            })
            .then(() => {
                unpushedTrackEventsStack.forEach(trackData => {
                    const region = getRegionByHost();
                    trackData.attr = merge(trackData.attr, {
                        region
                    });
                    Raven.insertMeta(trackData);
                });
                unpushedTrackEventsStack = [];
            });
    }
};

const RavenInsertMeta = (category, action, attr) => {
    if (!Raven.insertMeta) {
        return;
    }
    const region = getRegionByHost();
    attr = merge({
        source: get(window, 'zPREFACE.trackData.source', category),
        region
    }, attr);
    const trackData = {
        module: category,
        action,
        attr
    };
    Raven.insertMeta(trackData);
};

Raven.insertMeta = Raven.insertMeta
    ? Raven.insertMeta
    : (trackData) => {
        console.warn('ps-tracer not inited!');
        unpushedTrackEventsStack.push(trackData);
    };

const RavenInsertMetaGrowth = function (action, attr) {
    return RavenInsertMeta('Growth Eng', action, attr);
};

export { RavenInsertMeta, Raven, RavenInsertMetaGrowth };
